import React, { Component } from "react";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import UserService from "../../services/UserService";
// import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import tableRequest from "../../models/tableRequest";
import { confirmAlert } from "react-confirm-alert"; // Import
import { BreadCrumb } from "primereact/breadcrumb";
import { Card } from "primereact/card";
import $ from "jquery";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
export default class UserMaster extends Component {
  constructor(props) {
    super(props);
    //   this.ApiService = new ApiService();
    this.UserService = new UserService();

    this.tblResponse = new tableRequest();
    this.state = {
      heads: [
        "CompanyName",
        "FirmName",
        "UserName",
        "FirstName",
        "LastName",
        "Email",
        "MobileNo",
        "CreatedDt",
      ],
      compDisabled: false,
      visible: false,
      ReferenceID: "",
      updateLoader: false,
      sortIcon: false,
      UserId: 0,
      UserName: "",
      FirstName: "",
      LastName: "",
      Email: "",
      MobileNo: "",
      Password: "",
      ConfirmPassword: "",
      IsActive: false,
      sortOrder: "",

      formError: {
        UserName: "",
        FirstName: "",
        LastName: "",
        Password: "",
        Email: "",
        ConfirmPassword: "",
        MobileNo: "",
      },

      formHeading: "Add User",
      buttonLabel: "Submit",

      first: 0,
      rows: 5,
      totalRecords: 0,
      globalFilter: null,
      emptyMessage: "No Data found",
      UserType: 0,
    };

    this.actionTemplate = this.actionTemplate.bind(this);
    this.emailTemplate = this.emailTemplate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.hideFunc = this.hideFunc.bind(this);
    this.onPage = this.onPage.bind(this);
    this.searchFilter = this.searchFilter.bind(this);
    this.openDialog = this.openDialog.bind(this);
    this.onSort = this.onSort.bind(this);
    // this.onValueChange = this.onValueChange.bind(this);
    // this.GetUserExport = this.GetUserExport.bind(this);
  }
  componentDidMount() {
    setTimeout(() => {
      this.GetUserMasterDetails();
    }, 1000);

    $(".p-column-title").on("click", function () {
      $(this)
        .next()
        .removeClass("pi-sort")
        .toggleClass("pi-sort-up")
        .addClass("pi-sort-down");
    });

    //this.tblResponseExport.PageSize = -1;
    // this.tblResponseExport.First = 1;
    // this.tblResponseExport.IsActive = true;
    // this.tblResponseExport.SearchValue = "";
    // this.tblResponseExport.SortOrder = "ASC";
    //this.GetUserExport();
  }

  // get user data list from api
  // GetUserExport() {
  //     this.tblResponseExport.SortColumn = "CreatedDt";
  //     this.UserService.GetUserMasterDetails(this.tblResponseExport).then((data) => {
  //         const resdata = data.data;
  //         //when response data is not null
  //         if (
  //             resdata !== null &&
  //             resdata.ResponseData !== null &&
  //             resdata.ResponseData?.length > 0
  //         ) {
  //             this.setState({
  //                 exportData: resdata.ResponseData,
  //             });
  //         }
  //     });
  // }

  //on page loading
  onPage(event) {
    this.setState({});

    //imitate delay of a backend call
    setTimeout(() => {
      this.getLazyLoadingValues(event);
      this.GetUserMasterDetails();
    }, 250);
  }

  getLazyLoadingValues(event) {
    this.setState({ rows: event.rows });
    this.tblResponse.PageSize = event.rows;
    this.tblResponse.First = event.first + 1;
    this.tblResponse.IsActive = true;
    this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
    //this.tblResponse.SortColumn = event.sortField;
    this.tblResponse.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    this.tblResponse.UserType = 0;
  }

  // get users data list from api
  GetUserMasterDetails() {
    this.tblResponse.SortColumn = "CreatedDt";
    this.UserService.GetUserMasterDetails(this.tblResponse).then((data) => {
      const resdata = data.data;
      //if response data is not null sales state will be set with ResponseData
      if (
        resdata !== null &&
        resdata.ResponseData !== null &&
        resdata.ResponseData?.length > 0
      ) {
        this.datasource = resdata.ResponseData;
        this.setState({
          totalRecords: resdata.ResponseData[0].TotalRows,
          first: this.tblResponse.First - 1,
          sales: this.datasource.slice(
            0,
            this.tblResponse.First - 1 + this.tblResponse.PageSize
          ),
          //loading: false,
          updateLoader: true,
        });
      }
      //if response data is null sales state will be set null
      else {
        this.datasource = null;
        this.setState({
          totalRecords: 0,
          first: 1,
          sales: null,
          // loading: false,
          updateLoader: true,
        });
      }
    });
  }

  // call every change of form and validation part also
  handleChange(event) {
    const { name, value } = event.target;
    let errors = this.state.formError;

    this.validateForm(value, name);
    this.setState({ errors, [name]: value });

    //to set state of IsActive
    if (name == "IsActive")
      this.setState({
        IsActive: event.target.checked,
      });
  }

  //to validate form
  validateForm(value, name) {
    let errors = this.state.formError;
    let IsValid = true;
    //to validate each form field with required conditions
    switch (name) {
      // case "UserName":
      //     if (value.length < 1) {
      //         IsValid = false;
      //         errors.UserName = "Please enter your UserName.";
      //     } else errors.UserName = "";
      //     break;
      case "FirstName":
        if (value.length < 1) {
          IsValid = false;
          errors.FirstName = "Please enter your first name.";
        }
        // } else if (value.length >= 1) {
        //   if (!value.match(/^[A-Za-z]+$/)) {
        //     IsValid = false;
        //     errors.FirstName = "FirstName should be alpha only.";
        //   } else errors.FirstName = "";
        // }
        else errors.FirstName = "";
        break;
      case "LastName":
        if (value.length < 1) {
          IsValid = false;
          errors.LastName = "Please enter your last name.";
        }
        // else if (value.length >= 1) {
        //   if (!value.match(/^[A-Za-z]+$/)) {
        //     IsValid = false;
        //     errors.LastName = "LastName should be alpha only.";
        //   } else errors.LastName = "";
        // }
        else errors.LastName = "";
        break;
      case "Email":
        if (value.length < 1) {
          IsValid = false;
          errors.Email = "Please enter your email-id.";
        } else if (value.length >= 1) {
          if (!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
            IsValid = false;
            errors.Email = "Please enter valid email-id.";
          } else errors.Email = "";
        } else errors.Email = "";
        break;
      case "MobileNo":
        if (value.length < 1) {
          IsValid = false;
          errors.MobileNo = "Please enter your mobile no.";
        } else if (value.length >= 1) {
          if (!value.match(/^[6-9]\d{9}$/)) {
            IsValid = false;
            errors.MobileNo = "Please enter valid mobile no.";
          } else errors.MobileNo = "";
        } else errors.MobileNo = "";
        break;
      case "Password":
        if (!value && value.length < 1) {
          IsValid = false;
          errors.Password = "Please enter password.";
        } else if (!value.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{4,20}$/)) {
          IsValid = false;
          errors.Password =
            "Password should be minimum 4 characters long, 1 uppercase & 1 lowercase character with 1 number.";
        } else if (
          !value &&
          value.length >= 1 &&
          this.state.ConfirmPassword.length >= 1
        ) {
          errors.Password = "";
          errors.ConfirmPassword = "";
          if (!(value === this.state.ConfirmPassword)) {
            IsValid = false;
            errors.Password = "password does not match";
          } else errors.Password = "";
        } else errors.Password = "";
        break;

      case "ConfirmPassword":
        if (!value && value.length < 1) {
          IsValid = false;
          errors.ConfirmPassword = "Please enter confirm password.";
        } else if (value.length >= 1 && this.state.Password.length >= 1) {
          errors.Password = "";
          errors.ConfirmPassword = "";
          if (value !== this.state.Password) {
            IsValid = false;
            errors.ConfirmPassword =
              "New password and Confirm password should be same.";
          }
        } else if (
          !value &&
          value.length >= 1 &&
          this.state.Password.length >= 1
        ) {
          errors.Password = "";
          errors.ConfirmPassword = "";
          if (!(value === this.state.Password)) {
            IsValid = false;
            errors.ConfirmPassword = "Confirm password does not match";
          } else errors.ConfirmPassword = "";
        } else errors.ConfirmPassword = "";
        break;
      default:
        break;
    }

    return IsValid;
  }

  // reset form text value
  formReset() {
    this.setState({
      ReferenceID: "",

      UserName: "",
      FirstName: "",
      LastName: "",
      Email: "",
      MobileNo: "",
      Password: "",
      ConfirmPassword: "",
      IsActive: true,
    });
    let errors = this.state.formError;
    Object.entries(errors).map(([key, value]) => {
      errors[key] = "";
    });
  }

  hideFunc() {
    this.setState({
      visible: false,
      buttonLabel: "Submit",
      formHeading: "Add User",
    });
    this.formReset();
  }
  openDialog() {
    this.setState({ visible: true });
    this.formReset();
  }
  // submit form and create or update user
  submitForm(event) {
    event.preventDefault();

    let isfrmvalid = true;
    let checkerror = this.state.formError;

    Object.entries(checkerror).map(([key, value]) => {
      const val = this.state[key];
      let valid = this.validateForm(val, key);
      //form is not valid
      if (!valid) {
        this.setState({ checkerror: isfrmvalid });
        isfrmvalid = false;
      }
    });
    //form is valid
    if (isfrmvalid) {
      this.setState({ updateLoader: false });
      const formData = {
        UserId: this.state.UserId,
        UserName: this.state.UserName,
        FirstName: this.state.FirstName,
        LastName: this.state.LastName,
        Email: this.state.Email,
        MobileNo: this.state.MobileNo,
        Password: this.state.Password,
        ReferenceID: this.state.ReferenceID,
        IsActive: this.state.IsActive,
        UserType: this.state.UserType,
      };
      if (formData.UserId == 0) {
        setTimeout(() => {
          this.UserService.CreateUpdateUser(formData).then((data) => {
            const resdata = data.data;
            //if responsecode is 200 success message willl be shown else it will move to 'else statement'
            if (resdata !== null && resdata.ResponseCode === "200") {
              toast.success(resdata.ResponseMessage);
              ////this.refs.Messchild.showSuccess(resdata.ResponseMessage);
              this.setState({
                //loading: true,
                visible: false,
                updateLoader: true,
              });
              this.formReset();
              this.GetUserMasterDetails();
            } else if (resdata !== null && resdata.ResponseCode === "400") {
              this.setState({
                updateLoader: true,
              });
              toast.warning(resdata.ResponseMessage);
              ////this.refs.Messchild.showWarn(resdata.ResponseMessage);
            } else {
              this.setState({
                updateLoader: true,
              });
              toast.error(resdata.ResponseMessage);
              ////this.refs.Messchild.showError(resdata.ResponseMessage);
            }
          });
        }, 100);
      } else {
        setTimeout(() => {
          this.UserService.UpdateProfile(formData).then((data) => {
            const resdata = data.data;
            //if responsecode is 200 success message willl be shown else it will move to 'else statement'
            if (resdata !== null && resdata.ResponseCode === "200") {
              ////this.refs.Messchild.showSuccess(resdata.ResponseMessage);
              this.setState({
                //loading: true,
                visible: false,
                updateLoader: true,
              });
              if (
                formData.UserId.toString() === sessionStorage.getItem("UserId")
              ) {
                toast.success(resdata.ResponseMessage + ", Please Login Again");
                setTimeout(() => {
                  sessionStorage.removeItem("LoggedInUser");
                  window.location = "/login";
                }, 5000);
              } else {
                toast.success(resdata.ResponseMessage);
              }
              this.formReset();
              this.GetUserMasterDetails();
            } else if (resdata !== null && resdata.ResponseCode === "400") {
              this.setState({
                updateLoader: true,
              });
              toast.warning(resdata.ResponseMessage);
              ////this.refs.Messchild.showWarn(resdata.ResponseMessage);
            } else {
              this.setState({
                updateLoader: true,
              });
              toast.error(resdata.ResponseMessage);
              ////this.refs.Messchild.showError(resdata.ResponseMessage);
            }
          });
        }, 100);
      }
    }
  }

  // delete user data
  // deleteUser(UserId) {
  //     this.UserService.DeleteUser(UserId).then((data) => {
  //         const resdata = data.data;
  //         //if responsecode is 200 success message willl be shown else it will move to 'else statement'
  //         if (resdata !== null && resdata.ResponseCode === "200") {
  //             ////this.refs.Messchild.showSuccess(resdata.ResponseMessage);
  //             this.GetUserMasterDetails();
  //             const totlrecord = this.state.totalRecords - 1;
  //             const row = this.state.rows;

  //             if (this.tblResponse.First >= totlrecord) {
  //                 const _curntCursor = Math.round(totlrecord / row);
  //                 this.tblResponse.First = _curntCursor + 1;
  //             }
  //         } else if (resdata.ResponseCode === "400") {
  //            // //this.refs.Messchild.showWarn(resdata.ResponseMessage);
  //         } else {
  //             ////this.refs.Messchild.showError(resdata.ResponseMessage);
  //         }
  //     });
  // }
  //to get  company data for ddl

  searchFilter(e) {
    this.setState({
      // loading: true,
    });
    this.tblResponse.SearchValue = e.target.value;
    this.GetUserMasterDetails();
  }

  callbackFunction = (childData) => {
    this.setState({ message: childData });
  };

  // disabled checkbox
  activeTemplate(rowData, column) {
    return <input type="checkbox" disabled checked={rowData.IsActive} />;
  }

  // sort data
  onSort(event) {
    this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1 });
    const sortField =
      event.sortField == "CreatedDt" ? "CreatedDt" : event.sortField;
    this.tblResponse.SortColumn = sortField ? sortField : "";
    this.tblResponse.SortOrder = this.state.sortOrder === 1 ? "DESC" : "ASC";
    this.GetUserMasterDetails();
    const clickData = document.getElementsByClassName(
      "p-sortable-column-icon pi pi-fw pi-sort"
    );
    ////console.log(event);
  }
  emailTemplate = (rowData) => {
    let emails = rowData.Email;
    return <div className="scroll-content">{emails}</div>;
  };
  // edit form
  actionTemplate(rowData, column) {
    const editMode = (e) => {
      this.setState({
        buttonLabel: "Update",
        formHeading: "Update User",
        visible: true,
        ReferenceID: rowData.ReferenceID,
        UserId: rowData.UserId == null ? 0 : rowData.UserId,
        UserName: rowData.UserName,
        FirstName: rowData.FirstName,
        LastName: rowData.LastName,
        Email: rowData.Email,
        UserType: rowData.UserType,
        MobileNo: rowData.MobileNo,
        Password: rowData.Password,
        ConfirmPassword: rowData.Password,
        IsActive: rowData.IsActive,
      });
    };

    // const deleteFunc = () => {
    //     confirmAlert({
    //         title: "Confirm to delete",
    //         message: "Are you sure to do this.",
    //         buttons: [
    //             {
    //                 label: "Yes",
    //                 onClick: () => this.deleteUser(rowData.UserId),
    //             },
    //             {
    //                 label: "No",
    //                 onClick: () => null,
    //             },
    //         ],
    //     });
    // };

    return (
      <span>
        <Button
          type="button"
          icon="pi pi-pencil"
          onClick={editMode}
          className="p-button-warning"
          style={{ marginRight: "3px" }}
        ></Button>
        {/* <Button
                    type="button"
                    icon="pi pi-trash"
                    onClick={deleteFunc}
                    className="p-button-danger"
                ></Button> */}
      </span>
    );
  }

  // create html part
  //resolved KREP-85
  render() {
    const items = [{ label: "Masters" }, { label: "User Master" }];
   
    const home = { icon: "pi pi-home", url: "/dashboard" };


    let header = (
      <div style={{ textAlign: "right" }}>
        <i className="pi pi-search" style={{ margin: "4px 4px 0 0" }}></i>
        <InputText
          type="search"
          onInput={this.searchFilter}
          placeholder="Global Search"
          size="30"
        />
        <Button
          label="Add User"
          style={{ marginLeft: "8px" }}
          icon="pi pi-plus-circle"
          onClick={this.openDialog}
        />
        {/* <CSVLink
                    data={this.state.exportData}
                    headers={this.state.heads}
                    filename={"User Data.csv"}
                    target="_blank"
                >
                    <button
                        disabled={this.state.exportData.length == 0 ? true : false}
                        className="btn btn-success p-2 ml-2 buttone1"
                    >
                        <i className="pi pi-file-excel mr-2"></i>
                        Export
                    </button>
                </CSVLink> */}
      </div>
    );

    return (
      <>
       
        <Card className="mt5">
        <div className="row">
            <div className="col-md-6 heading master">
              <h3>User Master</h3>
            </div>
            <div className="col-md-6 custom-breadcrumb master">
            <BreadCrumb model={items} home={home} />
            </div>
          </div>
          <DataTable
            responsive={true}
            header={header}
            style={{ width: "100%" }}
            scrollable
            globalFilter={this.state.globalFilter}
            emptyMessage={this.state.emptyMessage}
            value={this.state.sales}
            sortMode="multiple"
            paginator={true}
            rows={this.state.rows}
            rowsPerPageOptions={[5, 10, 20]}
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            totalRecords={this.state.totalRecords}
            lazy={true}
            first={this.state.first}
            onPage={this.onPage}
            onSort={this.onSort}
            className="tblAuto"
          >
            {/* <Column
                                field="UserName"
                                headerStyle={{ width: "180px" }}
                                header="User Name"
                                sortable={true}
                            /> */}

            <Column
              field="FirstName"
              headerStyle={{ width: "160px" }}
              header="First Name"
              sortable={true}
            />
            <Column
              field="LastName"
              headerStyle={{ width: "160px" }}
              header="Last Name"
              sortable={true}
            />
            <Column
              body={this.emailTemplate}
              headerStyle={{ width: "200px" }}
              header="Email"
              sortable={true}
            />
            <Column
              field="MobileNo"
              headerStyle={{ width: "150px" }}
              header="Mobile No."
              sortable={true}
            />
            <Column
              field="CreatedDate"
              headerStyle={{ width: "150px" }}
              header="Created Date"
              sortable={true}
            />
            <Column
              body={this.activeTemplate}
              headerStyle={{ width: "80px" }}
              header="Status"
            />
            <Column
              body={this.actionTemplate}
              headerStyle={{ width: "100px" }}
              header="Action"
            />
          </DataTable>
        </Card>
        <Dialog
         className="popup1"
          header={this.state.formHeading}
          visible={this.state.visible}
          modal={true}
          onHide={this.hideFunc}
        >
          <form
            onSubmit={this.submitForm}
            className="form-padding mt-3 usermaster"
            autoComplete="off"
          >
            <div className="row update">
         

              <div className="col-md-4">
                <label>
                  First Name<span className="error">*</span>  &nbsp;: 
                </label>
              </div>
              <div className="col-md-8 mb-2">
                <input
                  type="text"
                  value={this.state.FirstName}
                  onChange={this.handleChange}
                  className="form-control"
                  name="FirstName"
                />
                <div className="error">{this.state.formError.FirstName}</div>
              </div>
              <div className="col-md-4">
                <label>
                  Last Name<span className="error">*</span>  &nbsp;: 
                </label>
              </div>
              <div className="col-md-8 mb-2">
                <input
                  type="text"
                  value={this.state.LastName}
                  onChange={this.handleChange}
                  className="form-control"
                  name="LastName"
                />
                {this.state.formError.LastName !== "" ? (
                  <div className="error">{this.state.formError.LastName}</div>
                ) : (
                  ""
                )}
              </div>
              <div className="col-md-4">
                <label>
                  Email<span className="error">*</span>  &nbsp;:
                </label>
              </div>
              <div className="col-md-8 mb-2">
                <input
                  type="text"
                  autoComplete="off"
                  value={this.state.Email}
                  onChange={this.handleChange}
                  className="form-control"
                  name="Email"
                />
                {this.state.formError.Email !== null ? (
                  <div className="error">{this.state.formError.Email}</div>
                ) : null}
              </div>
              <div className="col-md-4 ">
                <label>
                  Mobile Number<span className="error">*</span>  &nbsp;:
                </label>
              </div>
              <div className="col-md-8 mb-2">
                <input
                  type="text"
                  autoComplete="off"
                  maxLength={10}
                  value={this.state.MobileNo}
                  onChange={this.handleChange}
                  className="form-control"
                  name="MobileNo"
                />
                {this.state.formError.MobileNo !== null ? (
                  <div className="error">{this.state.formError.MobileNo}</div>
                ) : null}
              </div>
              <div className="col-md-4">
                <label>
                  Password<span className="error">*</span>  &nbsp;:
                </label>
              </div>
              <div className="col-md-8 mb-2">
                <input
                  type="password"
                  autoComplete="new-password"
                  value={this.state.Password}
                  onChange={this.handleChange}
                  className="form-control"
                  name="Password"
                  noValidate
                />
                {this.state.formError.Password !== null ? (
                  <div className="error">{this.state.formError.Password}</div>
                ) : null}
              </div>
              <div className="col-md-4">
                <label>
                  Confirm Password<span className="error">*</span> &nbsp;:
                </label>
              </div>
              <div className="col-md-8 mb-2">
                <input
                  type="password"
                  autoComplete="off"
                  value={this.state.ConfirmPassword}
                  onChange={this.handleChange}
                  className="form-control"
                  name="ConfirmPassword"
                />
                {this.state.formError.ConfirmPassword !== null ? (
                  <div className="error">
                    {this.state.formError.ConfirmPassword}
                  </div>
                ) : null}
              </div>

              <div className="col-md-4">
                <label>IsActive  &nbsp;:</label>
              </div>
              <div className="col-md-2 mt-2 text-left">
                <input
                  type="checkbox"
                  checked={this.state.IsActive}
                  className="ml-2"
                  name="IsActive"
                  onChange={this.handleChange}
                />
              </div>
              <div className="col-md-6 mt-2 text-center">
                <button type="submit" className="btn btn-primary">
                  {this.state.buttonLabel}
                </button>
              </div>

              <div className="col-md-12 ">
                <label>
                  Note: Fields marked as (
                  <span className="error">*</span>) are required
                </label>
              </div>
            </div>
          </form>
        </Dialog>
        <ToastContainer />
      </>
    );
  }
}
